import { useGenUiI18n } from '../../../../shared/ui/i18n.js';
import { sumItems } from '@voll-intelligence/intelligence-ui-kit/checkout';
import type { CheckoutCardSlots } from '../../ui/card_slots.js';
import { SummaryFoot } from '../../ui/summary_foot.js';
import { BusCheckoutLegs, busTotalNote, type BusCheckoutItem } from './checkout_legs.js';

/** O card do ônibus: os trechos com as poltronas, a conferência do 1-Click e o
 *  rodapé com o total e a forma da viagem («ida e volta, por pessoa»). */
export function BusCheckoutCard({
  items,
  slots,
}: {
  readonly items: readonly BusCheckoutItem[];
  readonly slots: CheckoutCardSlots;
}) {
  const { t } = useGenUiI18n();
  return (
    <>
      <div className="checkout__body">
        <BusCheckoutLegs items={items} />
      </div>
      {slots.review}
      <SummaryFoot
        valueKey="common.total"
        value={sumItems(items)}
        caption={busTotalNote(items, t)}
        inPolicy={slots.flow.withinPolicy}
        shieldAriaKey="productCheckout.outOfPolicy"
        shieldTitleKey="productCheckout.outOfPolicy"
        actions={slots.actions('productCheckout.reserveBus')}
      />
    </>
  );
}
